import { render } from "./Detail.vue?vue&type=template&id=e8db54ba"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
script.render = render

export default script